const Search = {
    init() {
        const navSearch = document.querySelector('.nav-search');
        const openSearchBtns = [...document.querySelectorAll('.js-nav-primary-open-search')];
        const searchCloseBtn = document.querySelector('.js-search-close');
        const searchInput = document.querySelector('.js-nav-search__form-input');
        const skipToSearchLink = document.querySelector('.skiplink[href="#search"]');

        // The overlay only hides via inert, so remember its opener to restore focus on close.
        let lastTrigger = null;

        const openSearch = trigger => {
            lastTrigger = trigger || null;
            navSearch.removeAttribute('inert');
            document.body.classList.add('nav-search--is-open');
            searchInput.focus();
        };

        const closeSearch = () => {
            document.body.classList.remove('nav-search--is-open');
            navSearch.setAttribute('inert', '');
            if (lastTrigger) {
                lastTrigger.focus();
                lastTrigger = null;
            }
        };

        if (openSearchBtns.length && searchCloseBtn) {
            openSearchBtns.forEach(btn => {
                btn.addEventListener('click', () => openSearch(btn));
            });
            searchCloseBtn.addEventListener('click', closeSearch);

            window.addEventListener('keydown', e => {
                if (e.key === 'Escape' && document.body.classList.contains('nav-search--is-open')) {
                    closeSearch();
                }
            });
        }

        if (skipToSearchLink) {
            skipToSearchLink.addEventListener('click', e => {
                e.preventDefault();
                openSearch(skipToSearchLink);
            });
        }
    },
};

export default Search;
